// The weekly opening hours' history as the Settings editor shows it
// (backend: tools/opening_hours_versions.py). Pure (unit-tested).

import { i18n } from '@/i18n'
import { formatDate } from '@/i18n/format'

// Weekday names are the DATA keys of the hours; only their short labels are translated.
const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const t = (key, params) => i18n.global.t(key, params || {})
const short = (day) => t(`openingHours.dayShort.${day}`)
const hm = (t) => String(t || '').slice(0, 5)

function dayText(d) {
  if (!d || !d.isOpen) return t('openingHours.summaryClosed')
  if (d.is24h) return t('openingHours.allDay')
  const base = `${hm(d.open)}–${hm(d.close)}`
  return d.hasLunch && d.lunchStart && d.lunchEnd ? `${base} ${t('openingHours.summaryLunch', { from: hm(d.lunchStart), to: hm(d.lunchEnd) })}` : base
}

// "Mon–Fri 09:00–18:00 · Sat 09:00–17:00 · Sun closed": consecutive days with the same
// hours grouped.
export function weekSummary(hours) {
  const parts = []
  let i = 0
  while (i < DAYS.length) {
    const text = dayText((hours || {})[DAYS[i]])
    let j = i
    while (j + 1 < DAYS.length && dayText((hours || {})[DAYS[j + 1]]) === text) j++
    parts.push(`${short(DAYS[i])}${j > i ? `–${short(DAYS[j])}` : ''} ${text}`)
    i = j + 1
  }
  return parts.join(' · ')
}

// [{ when: 'Since always' | 'From 21 Oct 2026', summary, current }] newest first.
export function versionRows(versions, todayIso) {
  const rows = (versions || []).map((v) => ({
    validFrom: v.validFrom || null,
    when: v.validFrom
      ? t('openingHours.historyFrom', { date: formatDate(v.validFrom, { style: 'medium' }) })
      : t('openingHours.historySince'),
    summary: weekSummary(v.hours),
  }))
  const current = [...rows].reverse().find((r) => !r.validFrom || r.validFrom <= todayIso)
  return rows.map((r) => ({ ...r, current: r === current, upcoming: !!r.validFrom && r.validFrom > todayIso })).reverse()
}
